module.exports = __webpack_public_path__ + "static/img/Adam-Reynolds.4621e79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Adam-Reynolds.jpg
// module id = Kyum
// module chunks = 0